module.exports = __webpack_public_path__ + "img/pic-goal.b20edfe.webp";